<div title="Rental agreement status: {{ displayName() }}">
  @switch (status()) {
    @case (0) {
      <span
        class="badge rounded-pill text-bg-success border border-success fw-bolder align-middle"
        style="font-size: 16px">
        <i class="fa-regular fa-circle-check"></i>
        {{ displayName() }}</span
      >
    }
    @case (1) {
      <span
        class="badge rounded-pill bg-light text-secondary border border-secondary align-middle"
        style="font-size: 16px">
        <i class="fa-regular fa-eye-slash"></i>
        {{ displayName() }}
      </span>
    }
    @case (2) {
      <span class="badge rounded-pill text-bg-warning border border-warning align-middle" style="font-size: 16px">
        <i class="fa-solid fa-ban"></i>
        {{ displayName() }}
      </span>
    }
    @case (3) {
      <span class="badge rounded-pill text-success bg-light border border-success align-middle" style="font-size: 16px">
        <i class="fas fa-hourglass-half"></i>
        {{ displayName() }}
      </span>
    }
    @case (4) {
      <span
        class="badge rounded-pill bg-light text-secondary border border-secondary align-middle"
        style="font-size: 16px">
        <i class="fa-regular fa-times-circle"></i>
        {{ displayName() }}
      </span>
    }
    @default {
      <span
        class="badge rounded-pill bg-light border border-secondary text-secondary align-middle"
        style="font-size: 16px"
        >{{ displayName() }}</span
      >
    }
  }
</div>
